import clsx from "clsx";

import { loadLocale } from "@smart/itops-locale-dom";
import { FileUpload } from "@smart/itops-sb-design-system-dom";

import { Appointment } from "./appointment";
import { DateDisplayer } from "./date";
import { EditChoice } from "./edit-choice";
import { Payment } from "./payment";
import { Signature } from "./signature";
import { LanguageKey } from "../../../types";
import { GqlFieldValues, OnUpdateField } from "../types";

type FieldBoxProps = {
  field: GqlFieldValues;
  onUpdateField: OnUpdateField;
  viewingLanguage: LanguageKey;
  hasSubmissionLinks?: boolean;
};

export const FieldBox = ({
  field,
  onUpdateField,
  viewingLanguage,
  hasSubmissionLinks,
}: FieldBoxProps) => {
  const { dateFormat } = loadLocale();
  const getBoxClassNames = (size: "small" | "large") =>
    clsx(
      "border border-solid border-neutral-200 rounded my-1 mx-0 bg-neutral-20 mx-[0.4rem]",
      size === "small" ? "h-16" : "h-[8rem]",
    );

  switch (field.type) {
    case "text":
    case "number":
    case "email":
    case "address":
    case "currency":
    case "phoneNumber":
      return (
        <div
          className={getBoxClassNames("small")}
          data-testid="small-text-box"
        />
      );
    case "file":
      return (
        <FileUpload
          id=""
          errorId=""
          sizeLimit="Max 5 files; Max 128 MB each."
          onSelect={() => {}}
          className="mx-[0.4rem]"
        />
      );
    case "multilineText":
      return (
        <div
          className={getBoxClassNames("large")}
          data-testid="large-text-box"
        />
      );
    case "date":
      return <DateDisplayer dateFormat={dateFormat} />;
    case "choice":
    case "checkbox":
      return (
        <EditChoice
          field={field}
          onUpdateField={onUpdateField}
          viewingLanguage={viewingLanguage}
        />
      );
    case "appointment":
      return (
        <Appointment
          field={field}
          onUpdateField={onUpdateField}
          viewingLanguage={viewingLanguage}
        />
      );
    case "payment":
      return (
        <Payment
          field={field}
          onUpdateField={onUpdateField}
          viewingLanguage={viewingLanguage}
        />
      );
    case "signature":
      return (
        <Signature
          field={field}
          onUpdateField={onUpdateField}
          hasSubmissionLinks={hasSubmissionLinks}
        />
      );
    default:
      return null;
  }
};
